var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.content.children.length
    ? _c(
        "ol",
        [
          _vm._l(_vm.content.children, function (obj, index) {
            return [
              _c(
                "li",
                { class: obj.header[0].bold ? "" : "term-box" },
                [
                  obj.header[0].bold
                    ? [
                        _c("div", { staticClass: "third-title" }, [
                          _vm._v(
                            _vm._s(_vm.parentIndexes[0] + 1) +
                              "." +
                              _vm._s(index + 1) +
                              " " +
                              _vm._s(obj.header[0].content)
                          ),
                        ]),
                        _vm._v(" "),
                        _vm._l(obj.header.slice(1), function (main) {
                          return _c("p", {
                            domProps: { innerHTML: _vm._s(main.content) },
                          })
                        }),
                      ]
                    : [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.parentIndexes[0] + 1) +
                            "." +
                            _vm._s(index + 1)
                        ),
                        _c("p", { staticClass: "term" }, [
                          _vm._v(_vm._s(obj.header[0].content)),
                        ]),
                      ],
                ],
                2
              ),
              _vm._v(" "),
              _c("Depth4Sub", {
                key: index,
                attrs: {
                  parentIndexes: [_vm.parentIndexes[0], index],
                  content: obj,
                },
              }),
            ]
          }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }